import { Language } from 'generated/mos/i18n';

export const DEFAULT_SITE_REF_ID = '016e9079-0615-b58f-f447-05a98e7c9510';

export type LanguageCode = 'en' | 'es' | 'fr' | 'de' | 'it' | 'ja' | 'ko' | 'zh' | 'pt' | 'ru';

export const LANGUAGES: ReadonlyArray<Language.Entity> = [
  { languageCode: 'en', variant:'US', type: "mos.i18n.Language" },
  { languageCode: 'es', variant:'', type: "mos.i18n.Language" },
  { languageCode: 'fr', variant:'', type: "mos.i18n.Language" },
  { languageCode: 'de', variant:'', type: "mos.i18n.Language" },
  { languageCode: 'it', variant:'', type: "mos.i18n.Language" },
  { languageCode: 'ja', variant:'', type: "mos.i18n.Language" },
  { languageCode: 'ko', variant:'', type: "mos.i18n.Language" },
  { languageCode: 'zh', variant: 'Hans', type: "mos.i18n.Language" },
  { languageCode: 'pt', variant: 'BR', type: "mos.i18n.Language" },
  { languageCode: 'ru', variant:'', type: "mos.i18n.Language" },
]

export const JIRA_SERVICE_DESK_URL = 'https://artprocessors.atlassian.net/servicedesk/customer/portals'


/**
 * Timezone required for analytics queries
 * *
 * In CubeJS queries use timezone prop: 
 *    myCubeJsQuery = {
 *     [...]
 *     timezone: LOCAL_TIMEZONE,
 *     [...]
 *    }
 */
export const LOCAL_TIMEZONE = 'America/Los_Angeles'
